import { render, staticRenderFns } from "./FleetMarpolComplianceLarge.vue?vue&type=template&id=06ab98f8"
import script from "./FleetMarpolComplianceLarge.vue?vue&type=script&lang=js"
export * from "./FleetMarpolComplianceLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports